import { ENVIRONMENT } from '~/vendor/cx-sdk/constants';
import { z } from 'zod';

export const environmentSchema = z.enum(
  Object.values(ENVIRONMENT) as [keyof typeof ENVIRONMENT, ...(keyof typeof ENVIRONMENT)[]],
);
export type Environment = z.infer<typeof environmentSchema>;
